
















import Vue from 'vue'
import appsBar from './components/bar/appsBar/appsBar.vue'
import loginCard from './components/card/loginCard/loginCard.vue'
import snackBar from './components/bar/snackBar/snackBar.vue'
import firebase from 'firebase'
const database = firebase.database()

export default Vue.extend({
  name: 'App',
  components: {
    appsBar,
    loginCard,
    snackBar
  },
  data: () => ({
    app: {}
  }),
  created () {
    this.app = this.$store.state.app
  },
  methods: {
    saveRecord () {
      let group = this.$store.state.groupCard
      let players:any = []
      group.list.forEach((col:any) => {
        group.group_player[col.name].forEach((player:any) => {
          player.color = col.color
          players.push(player)
        })
      })
      group.unform.forEach((player:any) => {
        players.push(player)
      })
      database.ref('/game_record/' + this.$store.state.loginCard.key + '/players').set(players)
      this.$store.commit('setSnackBar', {
        icon: 'far fa-check-circle',
        color: 'primary',
        status: true,
        text: 'All Records Updated',
        timeout: 2000
      })
    }
  }
})
